// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type DashboardSummaryQueryVariables = PrivateSchemaTypes.Exact<{
  dashboardId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filters: PrivateSchemaTypes.DashboardSummaryFiltersInput;
}>;


export type DashboardSummaryQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { dashboard?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DashboardModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.DashboardModelAsAdminQueries, 'id' | 'metric_name' | 'metric_target_value' | 'custom_metric' | 'isEditor' | 'commentedTopics' | 'commsPenetration' | 'resourcesPenetration'>
      & { currentAudienceCount: PrivateSchemaTypes.DashboardModelAsAdminQueries['audienceEventsCount'] }
      & { customMetricEntries?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'DashboardCustomMetricModel' }
        & Pick<PrivateSchemaTypes.DashboardCustomMetricModel, 'id' | 'timestamp' | 'value'>
      )>>, customMetricEntriesFiltered: Array<(
        { __typename?: 'DashboardCustomMetricModel' }
        & Pick<PrivateSchemaTypes.DashboardCustomMetricModel, 'id' | 'timestamp' | 'value'>
      )>, surveys: Array<(
        { __typename?: 'SurveyModel' }
        & Pick<PrivateSchemaTypes.SurveyModel, 'id' | 'title'>
      )>, userInsights: Array<(
        { __typename?: 'UserInsightResult' }
        & Pick<PrivateSchemaTypes.UserInsightResult, 'surveyId' | 'surveyTitle' | 'userId'>
      )>, ratedCurrentEnrolments: Array<(
        { __typename?: 'TopicEnrolmentModel' }
        & Pick<PrivateSchemaTypes.TopicEnrolmentModel, 'id' | 'rating'>
      )>, actionsEffectiveness: Array<(
        { __typename?: 'DashboardActionTypeReport' }
        & Pick<PrivateSchemaTypes.DashboardActionTypeReport, 'commName' | 'effectiveness' | 'processedActionsCount' | 'userEventsCount' | 'isCommEnabled'>
      )> }
    )> }
  )> }
);


export const DashboardSummaryDocument = gql`
    query dashboardSummary($dashboardId: PositiveInt!, $filters: DashboardSummaryFiltersInput!) {
  admin {
    dashboard(id: $dashboardId) {
      id
      metric_name
      metric_target_value
      custom_metric
      isEditor
      customMetricEntries {
        id
        timestamp
        value
      }
      customMetricEntriesFiltered(filters: $filters) {
        id
        timestamp
        value
      }
      surveys {
        id
        title
      }
      userInsights(filters: $filters) {
        surveyId
        surveyTitle
        userId
      }
      commentedTopics(filters: $filters)
      ratedCurrentEnrolments(filters: $filters) {
        id
        rating
      }
      commsPenetration(filters: $filters)
      resourcesPenetration(filters: $filters)
      actionsEffectiveness(filters: $filters) {
        commName
        effectiveness
        processedActionsCount
        userEventsCount
        isCommEnabled
      }
      currentAudienceCount: audienceEventsCount(types: [join])
    }
  }
}
    `;

/**
 * __useDashboardSummaryQuery__
 *
 * To run a query within a React component, call `useDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSummaryQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDashboardSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DashboardSummaryQuery, DashboardSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardSummaryQuery, DashboardSummaryQueryVariables>(DashboardSummaryDocument, options);
      }
export function useDashboardSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardSummaryQuery, DashboardSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardSummaryQuery, DashboardSummaryQueryVariables>(DashboardSummaryDocument, options);
        }
export type DashboardSummaryQueryHookResult = ReturnType<typeof useDashboardSummaryQuery>;
export type DashboardSummaryLazyQueryHookResult = ReturnType<typeof useDashboardSummaryLazyQuery>;
export type DashboardSummaryQueryResult = Apollo.QueryResult<DashboardSummaryQuery, DashboardSummaryQueryVariables>;